module.exports = __webpack_public_path__ + "static/media/eduok-icon.4bab8f4c.png";